import React, {Component, Fragment, createRef, useState, useRef} from 'react';
import {Globals, handleAjaxError, checkError, getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import VanillaModal from "root/Modals/VanillaModal/VanillaModal";
import UserInput from "root/UI/ReactUserInput";
import {UserTypes} from "root/DataFunctions/Constants";
import ModalAcceptableUsePolicy from "./ModalAcceptableUsePolicy";
import Modal from "react-responsive-modal";
import {fromBase64} from "js-base64";
import {doRegister, doPasswordReset} from "root/DataFunctions/LoginFns";
import useModalProvideFeedback from "root/Modals/ProvideFeedback/useModalProvideFeedback";
import phpVars from 'phpVars';

const LoginForm = (props) =>
{
	const [renderFeedbackModal, showFeedbackModal] = useModalProvideFeedback(null,(result) =>
	{
		// do nothing
	})

	const USER_TYPE_FIELD_NAME = 'userTypeId' ;
	const USER_ID_FIELD_NAME = 'idusers' ;
	const LOGIN_URL = "/login/login" ;
	const WELCOME_TITLE = "Welcome to the Arcbox!"

	const [ mode, setMode ] = useState ( props.mode === '' || props.mode === null || props.mode === undefined ? 'login' : props.mode ) ;
	const [ user_type, setUserType ] = useState ( props.user_type ) ;
	const [ pinRequired, setPinRequired ] = useState ( false ) ;
	const [ user_id, setUserId ] = useState ( props.user_id ) ;
	const [ user, setUser ] = useState ( [] ) ;
	const [ error, setError ] = useState ( { displayErrors : false, formError: null} ) ;

	const inpEstablishmentNumber = useRef(null);
	const inpUsername = useRef(null);
	const inpOldPassword = useRef(null);
	const inpPassword1 = useRef(null);
	const inpPassword = useRef(null);
	const inpPIN = useRef(null);

	const [ dialogAcceptableUseOpen, setDialogAcceptableUseOpen ] = useState (false);

	const doSetFocus = () =>
	{
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
				inpEstablishmentNumber.current.focus() ;
				break ;			
			case 'change_password' :
				inpOldPassword.current.focus() ;
				break ;			
			case 'change_password_first' :
			case 'register' :
			case 'activate' :
				inpPassword.current.focus() ;
				break ;
			case 'forgot_password' :
				inpEstablishmentNumber.current.focus() ;
				break ;			
		}	
	}

	const redirectKnownUserType = ( user_type, use_teen_interface) =>
	{
        switch (+user_type)
        {
            case UserTypes.CHILD :
				//LIF-1583 Check if user has use_teen_interface login set
				if(use_teen_interface == 1){
					window.location.replace("/arcom/home");
				}
				else{
					window.location.replace("/arcom/child");
				}

				break;

            default:
				window.location.replace("/arcom/home");
                break;
        }
	}
	
	const doPasswordResetConfirmation = ( user ) =>
	{
		dialogShow ( 'Password Reset Accepted', '<p>You have successfully requested a password reset. Please check your email for confirmation and further instructions.</p>',
			() => {
				setMode ( 'login') ;
			} ) ;
	}

	const doLoginFunctions = ( user ) =>
	{
        const user_type = user[USER_TYPE_FIELD_NAME];
        const userid = user[USER_ID_FIELD_NAME];
		const use_teen_interface = user['use_teen_interface'];
        
		if ( +(user.password_change_required) === 1 )
		{
			dialogShow ( 'Successful Login', '<p>You have successfully logged in, but you must now change your password before continuing.</p>',
				() => {
					setMode ('change_password_first') ;
					setUserType(user_type);
					setUserId (userid) ;
				} ) ;
		}
		else
		{
            redirectKnownUserType ( user_type, use_teen_interface ) ;
		}
	}

	const doChangePassword = ( userid, formData ) =>
	{
		const url = Globals.APIFolder + '/users/' + userid+ '/changePassword' ;

        $.ajax({
            type: 'POST',
            url: url ,
			data:formData,
            success:(data)=>{

    			if ( checkError(data))
				{
    				redirectKnownUserType ( user_type )
				}  				

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
		
	}
	
	/*const doChangeCurrentUserPassword = ( oldpass, newpass ) =>
	{
		const url = Globals.APIFolder + '/changepassword' ;

		let data = { oldpassword: oldpass, password: newpass } ;
		
        $.ajax({
            type: 'PUT',
            url: url ,
            data: { data },
            success:(data)=>{

    			if ( checkError(data))
				{
					dialogShow ( 'Password change successful', '<p>Your password has now been changed.</p>',
						() => {
							setMode('password_changed') ;
						} ) ;
				}

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
	}*/
//removed this inpEstablishmentNumber: establishment

	const dialogShow = ( title, message, action ) =>
	{
		let cfrm = new VanillaModal ({
			title: title,
			content: message,
			buttons: VanillaModal.buttons.alert
		})

		// Listen for `hide` event.
		/* cfrm.on('hide', function() {
			alert('Triggered hide event.');
		}); */

		// Listen for `hidden` event.
		/* cfrm.on('hidden', function() {
			alert('Modal is hidden.');
		}); */

		/* cfrm.on('dismiss', function() {
			alert('Modal is hidden.');
		}); */

		cfrm.show().once('dismiss', (modal, ev, button) => {
		if (button && button.value) {
			action() ;
		}
		});
	}

	const doLogin = ( formData ) =>
	{
		const url = Globals.APIFolder + LOGIN_URL;
		let data = { inpUsername: formData.username, inpPassword: formData.password } ;

		if ( pinRequired )
		{
			data = { ...data, inpPIN: formData.pin}
		}

    	$.ajax({
    		  type: 'POST',
    		  url: url,
    		  data: data ,
    		  success:(data)=>
    		  {
    		  	if ( checkError(data))
				{
					const return_data = getDataFromResponse(data)[0];

					if ( return_data.login_result === 'success')
					{
						var user = return_data ;

						if ( user.acceptable_usage_terms_agree_date !== undefined && user.acceptable_usage_terms_agree_date == null )
						{
							setMode ('acceptable_use_policy') ;
							setUser(user) ;
							setDialogAcceptableUseOpen (true);
						}
						else
						{
							doLoginFunctions( user );
						}
					}
					else if ( return_data.reason === 'mfa_required')
					{
						setPinRequired( true ) ;
					}
					else if ( return_data.reason === 'mfa_invalid')
					{
						const message = '<p>Your PIN number is invalid. Please try again.</p>';
						dialogShow ( 'Login Failed', message,
							() => {
							} ) ;
					}
					else if ( return_data.reason === 'mfa_expired')
					{
						const message = '<p>Your PIN number has expired. Please refresh your screen and try again.</p>';
						dialogShow ( 'Login Failed', message,
							() => {
							} ) ;
					}
					else
					{
						let message ='';

						switch(return_data.reason)
						{
							case 'invalid':
							case 'password':
								message = '<p>The credentials you entered are invalid. Please try again.</p>';
								break;

							case 'invited':
								message = '<p>You have not yet registered.</p><p>Please check for a registration email or contact your system administrator.</p>';
								break;

							case 'inactive':
								message = '<p>The account has not yet been activated.</p><p>Please check for an activation email or contact your system administrator.</p>';
								break;

							case 'suspended':
								message = 'The account has been suspended. Please contact your system administrator.</p>';
								break;

							case 'expired':
								message = '<p>Your Account has expired. Please contact your system administrator.</p>';
								break;
						}


						dialogShow ( 'Login Failed', message,
							() => {
								setMode ( 'login') ;
							} ) ;
					}
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
    		  {
					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
		  	  }

    		});
	}

	const doResetPasswordSet = ( newpass ) =>
	{
		const url = Globals.APIFolder + '/users/resetPassword' ;

		const data = {
			inpPassword: newpass,
			token: props.token
		} ;

		$.ajax({
			type: 'POST',
			url: url ,
			data: data,
			success:(data)=>
			{
				if ( checkError(data))
				{
					setMode( 'password_reset_complete')
				}
			},
			error:(jqXHR, textStatus, error)=>
			{
				handleAjaxError ( jqXHR, textStatus, error) ;
			}
		});

	}

	const onForgotPassword = () =>
	{
		setMode ('forgot_password') ;
	}

	const onProvideFeedback = () =>
	{
		showFeedbackModal(phpVars.user_id);
	}


	const onForgotPasswordCancel = () =>
	{
		setMode('login') ;
	}

	const onLogout = () =>
	{
		setMode('login') ;
	}

	const onCancel = () =>
	{
      	location.assign('home.php');
	}

	const onChangePasswordCancel = () =>
	{
		setMode ('change_password') ;
	}

	const formIsValid = () =>
	{
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
			case 'activate' :

				if ( inpUsername.current.isValid() && inpPassword.current.isValid())
				{
					if ( pinRequired )
					{
						return inpPIN.current.isValid() ;
					}
					else
					{
						return true ;
					}
				}
				else
				{
					return false ;
				}
				break ;
			case 'change_password_first' :
			case 'password_reset' :
			case 'change_password':
			case 'register' :
				if ( inpPassword.current.isValid() && inpPassword1.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'forgot_password' :
				if ( inpUsername.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
		}
		
		return false ;
	}

	const getFormData = () =>
	{
		let dataItem = {} ;
		
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
			case 'activate' :

				if ( pinRequired )
				{
					dataItem.pin= inpPIN.current.getValue() ;
				}

				dataItem.username= inpUsername.current.getValue() ;
				dataItem.password = inpPassword.current.getValue() ;

				break ;
			case 'change_password' :
				//dataItem.oldpassword= inpOldPassword.current.getValue() ;
				dataItem.password= inpPassword.current.getValue() ;
				dataItem.password1 = inpPassword1.current.getValue() ;
			case 'change_password_first' :
			case 'register' :
			case 'password_reset' :
				dataItem.password= inpPassword.current.getValue() ;
				dataItem.password1 = inpPassword1.current.getValue() ;
				break ;
			case 'forgot_password' :
				dataItem.username= inpUsername.current.getValue() ;
				//dataItem.establishment_number = getEstablishmentNumber();
				break ;
		}
		
		return dataItem ;
	}

	//removed this data.establishment_number
	const onLogin = (event) =>
	{
		event.preventDefault() ;
		
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;
			
			doLogin( data );
		}
	}

	const onRegister = (event) =>
	{
		event.preventDefault() ;

		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;

			if ( data.password !== data.password1 )
			{
				setError ({ displayErrors : true, formError: "Passwords must match"}) ;
			}
			else
			{
				doRegister(data.password, props.token,(response) =>
				{
					setMode ('register_complete') ;
				})
			}
		}
	}

	//removed this data.establishment_number from the else
	const onForgotPasswordSend = (event) =>
	{
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});

		}
		else
		{
			const data = getFormData() ;

			doPasswordReset ( data.username, (response) =>
			{
				doPasswordResetConfirmation( );
			})
		}
	}

	const onSavePasswordReset = (event) =>
	{
		event.preventDefault() ;

		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;

			doResetPasswordSet( data.password );
		}
	}

	const onChangePassword = (event) =>
	{
		event.preventDefault() ;
		
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: ''});
		}
		else
		{
			const data = getFormData() ;

			if ( data.password !== data.password1 )
			{
				setError({ displayErrors: true, formError: 'Passwords must match'});
			}
			else
			{
				doChangePassword( user_id, data );
			}
		}
	}

    const logo = ( image_path ) =>
    {
        return (
				<img src={image_path} alt='logo'/>
		)
    }
    
    const title = ( title ) =>
    {
        // return <h1>{title}</h1>
    }

	const renderUserNameInput = ( userAutoFocus, value ) =>
	{
		return <UserInput
			validation={{required: true, maxlen: 100 }}
			id='inpUsername'
			name='inpUsername'
			ref={inpUsername}
			autofocus={userAutoFocus}
			labelText={null}
			errorText='You must enter a valid username'
			placeholder='Username'
			tabIndex={2}
			value={value}
			displayErrors={error.displayErrors}
			containerClassName=''
			key='inpUsername' />
	}

	const renderPasswordInput = ( userAutoFocus, placeHolder ) =>
	{
		return <UserInput
			validation={{required: true, maxlen: 100 }}
			id='inpPassword'
			name='inpPassword'
			isPassword={true}
			ref={inpPassword}
			autofocus={userAutoFocus}
			labelText={null}
			errorText='You must enter a password'
			placeholder={placeHolder}
			tabIndex={3}
			value=''
			displayErrors={error.displayErrors}
			containerClassName=''
			key='inpPassword' />
	}

	const renderPINInput = (userAutoFocus, placeHolder) =>
	{
		return <Fragment>
			<p style={{marginTop: '10px', marginBottom: '10px', color: 'red'}} key='ac5'>Your account requires you to input a PIN number when logging on. This has been sent to your email address.</p>
			<UserInput
				validation={{required: true, maxlen: 6}}
				id='inpPIN'
				name='inpPIN'
				ref={inpPIN}
				autofocus={userAutoFocus}
				labelText={null}
				errorText='You must enter a PIN'
				placeholder={placeHolder}
				tabIndex={4}
				value=''
				displayErrors={error.displayErrors}
				containerClassName=''
				key='inpPIN'/>
		</Fragment>
	}

    const formElement = () =>
    {
    	let lineList = [] ;
    	let value = '' ;
    	let establishment_number = '';

		//let providerAutoFocus = false ;
    	let userAutoFocus = true ;
		let passwordAutoFocus = false ;

    	if ( mode === 'activate' )
		{
			lineList.push  (<p key='ac1'>Your account is now activated.</p>) ;
			lineList.push  (<p key='ac2'>Please enter your password below to log in.</p>) ;
			value = fromBase64(props.username) ;
			establishment_number = props.establishment_number ;
			//providerAutoFocus = false ;
			userAutoFocus = false ;
			passwordAutoFocus = true ;
		}
    	else if ( mode === 'password_reset_complete' )
		{
			lineList.push  (<p key='ac1'>Your password has been changed.</p>) ;
			lineList.push  (<p key='ac2'>Please enter your new password below to log in.</p>);
			value = fromBase64(props.username) ;
			//providerAutoFocus = true ;
			userAutoFocus = false ;
			passwordAutoFocus = false ;
		}
    	else if ( mode === 'login' && props.reason === 'inactive' )
		{
			userAutoFocus = true ;
			passwordAutoFocus = false ;
			establishment_number = props.establishment_number ;

			lineList.push (
				<div key='ssowarning' className='sso-warning'>
					<p>Your Single Sign-on has failed because your account is not yet activated.</p>
					<p>Please check your email for an activation invitation before attempting to login using Single Sign-On</p>
				</div>
			);
		}
		/*else if ( mode === 'login' && props.reason === 'invalid_school' )
		{
			establishment_number = props.establishment_number ;

			lineList.push (
				<div key='ssowarning' className='sso-warning'>
					<p>Your Single Sign-on has failed because your school is not enabled for Single Sign-On with Passport.</p>
					<p>Please contact your system administrator.</p>
				</div>
			);
		}*/

		/*if ( props.useProvider === true )
		{
			lineList.push ( renderEstablishmentInput ( providerAutoFocus, establishment_number )) ;
		}*/

		if ( props.reason === 'timeout' )
		{
			const style = {
				marginBottom: '15px',
				textAlign: 'center',
				color: '#ff263a'
			}

			lineList.push ( <div style={style}>Your session was logged out due to inactivity</div>) ;
		}

		lineList.push ( renderUserNameInput (userAutoFocus, value)) ;

		lineList.push ( renderPasswordInput (passwordAutoFocus, 'Password')) ;

		if ( pinRequired )
		{
			lineList.push ( renderPINInput(true, 'Please Enter Your PIN')) ;
		}

		lineList.push ( React.createElement ( 'button', { type: 'submit', key: 'btnLogin', className: 'btn btn-primary', id: 'submitBtn', onClick: onLogin }, 'Log in')) ;

    	return React.createElement ( 'form', { key: 'loginForm', className: 'form', id: 'login_form'},
			React.createElement ( 'div', { key: 'loginFormGroup', className: 'form-group'},
				lineList )) ;
    }

    const forgotPasswordformElement = () =>
    {
		return (
			<form className='form' id='login_form'>
				{ /* props.useProvider === true && renderEstablishmentInput ( true, '' ) */}
				{ renderUserNameInput(false, '') }
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' style={{marginBottom: '-5px'}} onClick={onForgotPasswordSend}>Reset Password</button>
				</div>
				<div className='form-group'>
					<button type='button' className='btn btn-secondary' id='cancelBtn' onClick={onForgotPasswordCancel}>Cancel</button>
				</div>
			</form>
		)
	}

	const registerElement = () =>
	{
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>{WELCOME_TITLE}</p>
				<p className='welcome-body'>Please choose a password ( at least 8 letters, including a number and an
					upper-case letter ) and click 'Register' to complete the registration process.</p>
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpPassword1}
					labelText={null}
					errorText={errorMessage}
					placeholder={'Confirm Password'}
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					containerClassName=''
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onRegister}>Register</button>
				</div>
			</form>
		)
	}

	const passwordReset = () =>
	{
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>Welcome to ARCBOX!</p>
				<p className='welcome-body'>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Reset Password'.</p>
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpPassword1}
					labelText={null}
					errorText={errorMessage}
					placeholder={'Confirm Password'}
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					containerClassName=''
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onSavePasswordReset}>Reset Password
					</button>
				</div>
			</form>
		)
	}

	const pStyle = {textAlign: 'center'} ;

	const registerCompleteElement = ( ) =>
	{
		return <form key='complete' className='form' id='login_form'>
			<p style={pStyle} key='rc1'>Thank You.</p>
			<p style={pStyle} key='rc2'>The registration process is almost complete.</p>
			<p style={pStyle} key='rc3'>You will now be sent an activation email which will contain a link that you can click to activate your account and log in. Please check your email now for the activation email.</p>
		</form>
	}

	const passwordChangeCompleteElement = () =>
	{
		return (
			<form key='passwordChangeComplete' className='form' id='login_form'>
				<p style={pStyle} key='pwc1'>Thank You.</p>
				<p style={pStyle} key='pwc2'>Your password has been changed.</p>
			</form>
		)
	}

	const changePasswordformElement = ( requireOldPassword ) =>
    {
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>Welcome to ARCBOX!</p>
				<p className='welcome-body'>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Change Password'.</p>
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpPassword1}
					labelText={null}
					errorText={errorMessage}
					placeholder='Confirm Password'
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onChangePassword}>Change Password</button>
				</div>
				{ mode === 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onLogout}>Logout</button>
				</div> }
				{ mode !== 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onChangePasswordCancel}>Cancel</button>
				</div> }
			</form>
		)
    }

	const onCloseAcceptableUseModal = (result) =>
	{
		if(result === 'logout'){
			setMode('login') ;
		}
		else{
			doLoginFunctions( user );
		}
	};

	const acceptableUseElement = () =>
	{
		return (
			<Modal key='acceptableUseModal' center={true} open={dialogAcceptableUseOpen} closeOnOverlayClick={false} focusTrapped={false} showCloseIcon={false} onClose={onCloseAcceptableUseModal}>
				<ModalAcceptableUsePolicy onClose={onCloseAcceptableUseModal}/>
			</Modal>
		)
	}

	const forgotPasswordLink = () =>
	{
		return (
			<p className='forgot-text' onClick={onForgotPassword}>Forgot Password</p>
		)
	}

	const feedbackLink = () =>
	{
		return (
			<p className='forgot-text' onClick={onProvideFeedback}>Feedback</p>
		)
	}

	const privacyLink = () =>
	{
		return (
			<a className='forgot-text' href='/arcom/assets/documents/ARCBOX_privacy_policy.pdf' target="_blank">Privacy Policy</a>
		)
	}

	const formBody = () =>
	{
		switch ( mode )
		{
			case 'login':
			case 'activate':
			case 'password_reset_complete' :
				return (
					<Fragment>
						{ formElement() }
						{ forgotPasswordLink() }
						{ feedbackLink() }
						{ privacyLink() }
						{renderFeedbackModal(props)}
					</Fragment>
				)
			case 'forgot_password':
				return forgotPasswordformElement() ;
			case 'change_password':
				return changePasswordformElement(false) ;
			case 'change_password_first':
				return changePasswordformElement(false) ;
			case 'register' :
				return registerElement() ;
			case 'password_reset':
				return passwordReset() ;
			case 'register_complete':
				return registerCompleteElement() ;
			case 'password_changed':
				return passwordChangeCompleteElement() ;
			case 'acceptable_use_policy':
				return acceptableUseElement() ;
		}
	}

	return (
		<div className='login-container-inner'>
			{ props.suppressLogo !== true && logo ( props.defaultLogo )}
			{ title(props.title) }
			{ formBody() }
		</div>
	)
}

export default LoginForm ;

LoginForm.defaultProps =
{
	mode: 'login',
	useProvider: true,
	suppressLogo: false,
	defaultLogo: '/images/logos/arclogo.png'
}
